import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { PlannerErrorPage } from "@/components/planner-error-page";
import { TakeoffWorkspace } from "@/components/takeoff-workspace";

const idSchema = z.uuid();

export const Route = createFileRoute("/project/$projectId/takeoff/$takeoffId/")(
	{
		component: TakeoffFrontpageRoute,
	},
);

function TakeoffFrontpageRoute(): ReactElement {
	const { t } = useTranslation();
	const { projectId, takeoffId } = Route.useParams();
	if (
		!idSchema.safeParse(projectId).success ||
		!idSchema.safeParse(takeoffId).success
	) {
		return (
			<PlannerErrorPage
				description={t("errors.invalidTakeoffLinkDescription")}
				title={t("errors.invalidTakeoffLink")}
			/>
		);
	}
	return <TakeoffWorkspace projectId={projectId} takeoffId={takeoffId} />;
}
